import isObject from "lodash/isObject";
import isString from "lodash/isString";
import isArray from "lodash/isArray";
import isInteger from "lodash/isInteger";
import isFinite from "lodash/isFinite";
import startsWith from "lodash/startsWith";
import merge from "lodash/merge";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import isNil from "lodash/isNil";
import isBoolean from "lodash/isBoolean";
import isDate from "lodash/isDate";
import get from "lodash/get";
import find from "lodash/find";
import debounce from "lodash/debounce";
import filter from "lodash/filter";
import includes from "lodash/includes";
import uniq from "lodash/uniq";
import values from "lodash/values";
import uniqBy from "lodash/uniqBy";
import isNumber from "lodash/isNumber";
import sortBy from "lodash/sortBy";
import forEach from "lodash/forEach";
import clamp from "lodash/clamp";
import findIndex from "lodash/findIndex";
import intersection from "lodash/intersection";
import flatMap from "lodash/flatMap";
import every from "lodash/every";
import pick from "lodash/pick";
import remove from "lodash/remove";
import padStart from "lodash/padStart";
import pickBy from "lodash/pickBy";
import keys from "lodash/keys";
import some from "lodash/some";
import omit from "lodash/omit";
import forOwn from "lodash/forOwn";
import isPlainObject from "lodash/isPlainObject";
import curry from "lodash/curry";
import concat from "lodash/concat";
import compact from "lodash/compact";
import inRange from "lodash/inRange";
import groupBy from "lodash/groupBy";
import memoize from "lodash/memoize";
import reduce from "lodash/reduce";
import cloneDeep from "lodash/cloneDeep";
import keyBy from "lodash/keyBy";
import camelCase from "lodash/camelCase";
import endsWith from "lodash/endsWith";
import orderBy from "lodash/orderBy";

let lodash = {
  isObject,
  isString,
  isArray,
  isInteger,
  isFinite,
  startsWith,
  merge,
  isEmpty,
  isEqual,
  get,
  find,
  debounce,
  filter,
  includes,
  uniq,
  values,
  uniqBy,
  isNil,
  isBoolean,
  isDate,
  isNumber,
  sortBy,
  forEach,
  clamp,
  findIndex,
  intersection,
  flatMap,
  every,
  pick,
  remove,
  padStart,
  pickBy,
  keys,
  some,
  omit,
  forOwn,
  isPlainObject,
  curry,
  concat,
  compact,
  inRange,
  groupBy,
  memoize,
  reduce,
  cloneDeep,
  keyBy,
  camelCase,
  endsWith,
  orderBy
};

export default lodash;
